import React, { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import Logo from "../../assets/logoWithName2.png";
import { logout } from "../../utils/helperFunctions";

function Menu({ isMenuOpen, toggleMenu }) {
  const [menuPos, setMenuPos] = useState(null);

  const dispatch = useDispatch();
  const toggleCollapse = (pos) => {
    setMenuPos((pre) => (pre == pos ? null : pos));
  };

  const handleClick = () => {
    logout(dispatch);
  };

  return (
    <>
      <aside class="left-sidebar">
        <div>
          <div class="brand-logo d-flex align-items-center justify-content-between">
            <Link to="/" class="text-nowrap logo-img">
              <img src={Logo} class="mt-3" width="395px" />
            </Link>
            <div
              class=" d-lg-none sidebartoggler cursor-pointer mt-3"
              id="sidebarCollapse"
              style={{
                position: "absolute",
                top: "-1%",
                left: "90%",
              }}
            >
              <i
                class={`ti ti-x fs-8 text-muted ${
                  isMenuOpen ? "text-primary" : ""
                }`}
                onClick={toggleMenu}
              ></i>
            </div>
          </div>
          <nav class="sidebar-nav scroll-sidebar" data-simplebar>
            <ul id="sidebarnav">
              <li class="nav-small-cap" onClick={toggleMenu}>
                <i class="ti ti-dots nav-small-cap-icon fs-4"></i>
                <span class="hide-menu">Home</span>
              </li>
              <li class="sidebar-item" onClick={toggleMenu}>
                <Link
                  class="sidebar-link"
                  to="/dashboard"
                  aria-expanded="false"
                >
                  <span>
                    <i class="ti ti-home"></i>
                  </span>
                  <span class="hide-menu">Dashboard</span>
                </Link>
              </li>
              <li class="sidebar-item" onClick={toggleMenu}>
                <Link
                  class="sidebar-link"
                  to="/dashboard/Profile"
                  aria-expanded="false"
                >
                  <span>
                    <i class="ti ti-home"></i>
                  </span>
                  <span class="hide-menu">Profile</span>
                </Link>
              </li>
              <li class="sidebar-item" onClick={() => toggleCollapse(0)}>
                <div
                  className={`sidebar-link has-arrow ${
                    menuPos == 0 ? "active" : ""
                  }`}
                  aria-expanded="false"
                >
                  <span class="d-flex">
                    <i class="ti ti-users"></i>
                  </span>
                  <span class="hide-menu">My Team</span>
                </div>
                <ul
                  aria-expanded="false"
                  class={`collapse first-level ${menuPos == 0 ? "in" : ""}`}
                >
                  <li class="sidebar-item" onClick={toggleMenu}>
                    <Link to="/dashboard/MyReferrals" class="sidebar-link">
                      <div class="round-16 d-flex align-items-center justify-content-center">
                        <i class="ti ti-users"></i>
                      </div>
                      <span class="hide-menu">My Referral</span>
                    </Link>
                  </li>
                  <li class="sidebar-item" onClick={toggleMenu}>
                    <Link to="/dashboard/MyTeam" class="sidebar-link">
                      <div class="round-16 d-flex align-items-center justify-content-center">
                        <i class="ti ti-circle"></i>
                      </div>
                      <span class="hide-menu">My Team</span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li class="sidebar-item" onClick={() => toggleCollapse(1)}>
                <div
                  className={`sidebar-link has-arrow ${
                    menuPos == 1 ? "active" : ""
                  }`}
                  aria-expanded="false"
                >
                  <span class="d-flex">
                    <i class="ti ti-currency-dollar"></i>
                  </span>
                  <span class="hide-menu">My Income</span>
                </div>
                <ul
                  aria-expanded="false"
                  class={`collapse first-level ${menuPos == 1 ? "in" : ""}`}
                >
                  <li class="sidebar-item" onClick={toggleMenu}>
                    <Link to="/dashboard/LevelIncome" class="sidebar-link">
                      <div class="round-16 d-flex align-items-center justify-content-center">
                        <i class="ti ti-circle"></i>
                      </div>
                      <span class="hide-menu">Level Income</span>
                    </Link>
                  </li>

                  <li class="sidebar-item" onClick={toggleMenu}>
                    <Link to="/dashboard/SalaryIncome" class="sidebar-link">
                      <div class="round-16 d-flex align-items-center justify-content-center">
                        <i class="ti ti-circle"></i>
                      </div>
                      <span class="hide-menu">Salary Income</span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li class="sidebar-item" onClick={toggleMenu}>
                <Link class="sidebar-link" to="/dashboard/StakeHistory">
                  <span class="d-flex">
                    <i class="ti ti-currency-dollar"></i>
                  </span>
                  <span class="hide-menu">Stake History</span>
                </Link>
              </li>
              <li class="sidebar-item" onClick={toggleMenu}>
                <Link class="sidebar-link" to="/dashboard/AirdropHistory">
                  <span class="d-flex">
                    <i class="ti ti-currency-dollar"></i>
                  </span>
                  <span class="hide-menu">Airdrop History(BLOCKAI)</span>
                </Link>
              </li>
              <li class="sidebar-item" onClick={() => toggleCollapse(2)}>
                <div
                  className={`sidebar-link has-arrow ${
                    menuPos == 2 ? "active" : ""
                  }`}
                  aria-expanded="false"
                >
                  <span class="d-flex">
                    <i class="ti ti-currency-dollar"></i>
                  </span>
                  <span class="hide-menu">Withdrawal</span>
                </div>
                <ul
                  aria-expanded="false"
                  class={`collapse first-level ${menuPos == 2 ? "in" : ""}`}
                >
                  <li class="sidebar-item" onClick={toggleMenu}>
                    <Link to="/dashboard/Withdrawal" class="sidebar-link">
                      <div class="round-16 d-flex align-items-center justify-content-center">
                        <i class="ti ti-users"></i>
                      </div>
                      <span class="hide-menu">Withdrawal</span>
                    </Link>
                  </li>
                  <li class="sidebar-item" onClick={toggleMenu}>
                    <Link
                      to="/dashboard/WithdrawalHistory"
                      class="sidebar-link"
                    >
                      <div class="round-16 d-flex align-items-center justify-content-center">
                        <i class="ti ti-circle"></i>
                      </div>
                      <span class="hide-menu">Withdrawal History</span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li class="sidebar-item" onClick={toggleMenu}>
                <Link to="/dashboard/support" class="sidebar-link">
                  <div class="round-16 d-flex align-items-center justify-content-center">
                    <i class="ti ti-ticket"></i>
                  </div>
                  <span class="hide-menu">Create Ticket</span>
                </Link>
              </li>
              <li
                class="sidebar-item"
                onClick={() => {
                  toggleMenu();
                  handleClick();
                }}
              >
                <div
                  class="sidebar-link"
                  aria-expanded="false"
                >
                  <span class="d-flex">
                    <i class="ti ti-logout"></i>
                  </span>
                  <span class="hide-menu">Logout</span>
                </div>
              </li>
            </ul>
          </nav>
          <div class="fixed-profile p-3 bg-light-secondary rounded sidebar-ad mt-3">
            <div class="hstack gap-3">
              <div class="john-img">
                <img
                  src="dist/images/profile/user-1.jpg"
                  class="rounded-circle"
                  width="40"
                  height="40"
                  alt=""
                />
              </div>
              <div class="john-title">
                <h6 class="mb-0 fs-4 fw-semibold">Mathew</h6>
                <span class="fs-2 text-dark">Designer</span>
              </div>
              <button
                class="border-0 bg-transparent text-primary ms-auto"
                tabindex="0"
                type="button"
                aria-label="logout"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-title="logout"
              >
                <i class="ti ti-power fs-6"></i>
              </button>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}

export default Menu;
